/* eslint-disable class-methods-use-this,@typescript-eslint/no-unused-vars */

import * as Yup from 'yup';
import { IFormDefinition } from '../formDefinitionInterface';
import { ISignInForm } from './types';

export class SignInFormDefinition implements IFormDefinition {
  public validationSchema: any = Yup.object().shape({
    email: Yup.string().email('Must use a valid email').required('Email is required'),
    password: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),
  });

  public initialValues(email = ''): ISignInForm {
    const values: ISignInForm = { email, password: '' };
    return values;
  }
}
